import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  CARGO_CORPORATE_CREDIT_PATH,
  CORPORATE_UNIT_PATH,
  MANUAL_VOUCHER_PAYMENT_PATH,
  MANUAL_VOUCHER_PAYMENT_RECONCILIATION_PATH,
  NEW_CARGO_CORPORATE_CREDIT_CITY_CUSTOMER_PATH,
  NEW_CARGO_CORPORATE_CREDIT_CITY_PATH,
  NEW_CARGO_CORPORATE_CREDIT_COMMON_PRODUCT,
  NEW_CARGO_CORPORATE_CREDIT_PATH,
  NEW_MANUAL_VOUCHER_PAYMENT_PATH,
  TICKET_CORPORATE_CREDIT_PATH,
} from '../../../config/paths';
import CorporateHome from './CorporateHome';
import CargoCorporateCredits from './cargo-corporate-credit/CargoCorporateCredits';
import NewCargoCorporateCredit from './cargo-corporate-credit/NewCargoCorporateCredit';
import CargoCorporateCredit from './cargo-corporate-credit/CargoCorporateCredit';
import EditCargoCorporateCredit from './cargo-corporate-credit/EditCargoCorporateCredit';
import AddCreditLineCargoCorporateCredit from './cargo-corporate-credit/AddCreditLineCargoCorporateCredit';
import NewCargoCorporateCreditCity from './cargo-corporate-credit/NewCargoCorporateCreditCity';
import NewCargoCorporateCreditCustomer from './cargo-corporate-credit/NewCargoCorporateCreditCustomer';
import NewCargoCorporateCreditCommonProduct from './cargo-corporate-credit/NewCargoCorporateCreditCommonProduct';
import NewCorporateParcelPriceConfiguration from './cargo-corporate-credit/NewCorporateParcelPriceConfiguration';
import NewCorporateParcelPriceSchedule from './cargo-corporate-credit/NewCorporateParcelPriceSchedule';
import TicketCorporateCredits from './ticket-corporate-credit/TicketCorporateCredits';
import TicketCorporateCredit from './ticket-corporate-credit/TicketCorporateCredit';
import AddCreditLineTicketCorporateCredit from './ticket-corporate-credit/AddCreditLineTicketCorporateCredit';
import ManualVoucherPayments from './manual-voucher-payment/ManualVoucherPayments';
import NewManualVoucherPayment from './manual-voucher-payment/NewManualVoucherPayment';
import ManualVoucherPayment from './manual-voucher-payment/ManualVoucherPayment';
import EditManualVoucherPayment from './manual-voucher-payment/EditManualVoucherPayment';
import ManualVoucherPaymentReconciliation from './manual-voucher-payment/ManualVoucherPaymentReconciliation';

const CorporateUnit = () => (
  <Switch>
    <Route exact path={CORPORATE_UNIT_PATH} component={CorporateHome} />

    <Route
      exact
      path={CARGO_CORPORATE_CREDIT_PATH}
      component={CargoCorporateCredits}
    />
    <Route
      exact
      path={NEW_CARGO_CORPORATE_CREDIT_PATH}
      component={NewCargoCorporateCredit}
    />
    <Route
      exact
      path={`${CARGO_CORPORATE_CREDIT_PATH}/:id`}
      component={CargoCorporateCredit}
    />
    <Route
      exact
      path={`${CARGO_CORPORATE_CREDIT_PATH}/:id/edit`}
      component={EditCargoCorporateCredit}
    />
    <Route
      exact
      path={`${CARGO_CORPORATE_CREDIT_PATH}/:id/add-credit-line`}
      component={AddCreditLineCargoCorporateCredit}
    />
    <Route
      exact
      path={NEW_CARGO_CORPORATE_CREDIT_CITY_PATH}
      component={NewCargoCorporateCreditCity}
    />
    <Route
      exact
      path={NEW_CARGO_CORPORATE_CREDIT_CITY_CUSTOMER_PATH}
      component={NewCargoCorporateCreditCustomer}
    />
    <Route
      exact
      path={NEW_CARGO_CORPORATE_CREDIT_COMMON_PRODUCT}
      component={NewCargoCorporateCreditCommonProduct}
    />
    <Route
      exact
      path={`${CARGO_CORPORATE_CREDIT_PATH}/:id/parcel-price-configuration`}
      component={NewCorporateParcelPriceConfiguration}
    />
    <Route
      exact
      path={`${CARGO_CORPORATE_CREDIT_PATH}/:id/parcel-price-schedule`}
      component={NewCorporateParcelPriceSchedule}
    />
    <Route
      exact
      path={TICKET_CORPORATE_CREDIT_PATH}
      component={TicketCorporateCredits}
    />
    <Route
      exact
      path={`${TICKET_CORPORATE_CREDIT_PATH}/:id`}
      component={TicketCorporateCredit}
    />
    <Route
      exact
      path={`${TICKET_CORPORATE_CREDIT_PATH}/:id/add-credit-line`}
      component={AddCreditLineTicketCorporateCredit}
    />
    <Route
      exact
      path={MANUAL_VOUCHER_PAYMENT_PATH}
      component={ManualVoucherPayments}
    />
    <Route
      exact
      path={NEW_MANUAL_VOUCHER_PAYMENT_PATH}
      component={NewManualVoucherPayment}
    />
    <Route
      exact
      path={`${MANUAL_VOUCHER_PAYMENT_PATH}/:id`}
      component={ManualVoucherPayment}
    />
    <Route
      exact
      path={`${MANUAL_VOUCHER_PAYMENT_PATH}/:id/edit`}
      component={EditManualVoucherPayment}
    />
    <Route
      exact
      path={`${MANUAL_VOUCHER_PAYMENT_RECONCILIATION_PATH}`}
      component={ManualVoucherPaymentReconciliation}
    />
  </Switch>
);

export default CorporateUnit;
